// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__561oP","sendOtp":"AuthorizeToLogin_sendOtp__bkXB2"};